import { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { LEGAL_DOCS } from "@/data/legal";
import { PageShell, ProseSection } from "@/components/ds";

const LegalPage = () => {
  const { slug } = useParams();
  const doc = LEGAL_DOCS[slug];

  useEffect(() => {
    if (doc) document.title = `${doc.title} — Zorem Commodities LLC`;
  }, [doc]);

  if (!doc) return <Navigate to="/" replace />;

  return (
    <div data-testid={`legal-page-${slug}`}>
      <PageShell eyebrow="Legal & Compliance" title={doc.title} updated={doc.updated}>
        <p className="text-base text-zinc-300 leading-relaxed mb-14 border-l-2 border-[#C9A227] pl-6">{doc.intro}</p>
        {doc.sections.map((s) => (
          <ProseSection key={s.heading} heading={s.heading}>
            {s.paras.map((p, i) => <p key={i}>{p}</p>)}
          </ProseSection>
        ))}
        <div className="mt-16 pt-10 hairline-t">
          <Link to="/" data-testid="legal-back-home" className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[#C9A227] hover:text-[#E8C85A] transition-colors">
            ← Return to Zorem Commodities
          </Link>
        </div>
      </PageShell>
    </div>
  );
};

export default LegalPage;
